import { AlgoliaSearchBoxProps } from '@/types/props/components';
import { useRouter } from 'next/router';
import handleKeyDown from '@/utilites/algolia/handle-key-down';
import { useTranslation } from 'next-i18next';
import translationFallback from '@/utilites/translations/translationFallback';
import event from '@/utilites/gTag';
import SpiritoryInput from '@/components/common/Forms/SpiritoryInput';
import { IoCloseOutline } from 'react-icons/io5';
import { useRef, useState } from 'react';
import clsx from 'clsx';
import { useSearchBox } from 'react-instantsearch';
export default function AlgoliaSearchBox({
  setShowResult,
  addButton,
  buttonProps,
  searchContainerClassName,
  inputClassName,
  saveSearchQuery,
  userId,
}: AlgoliaSearchBoxProps) {
  const { refine } = useSearchBox();
  const router = useRouter();
  const { t } = useTranslation('common');
  const [query, setQuery] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    return handleKeyDown(e, router.push, setShowResult);
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newQuery = e.target.value;
    setQuery(newQuery);

    if (saveSearchQuery) saveSearchQuery(newQuery);

    // Call the handleSearchQuery function to maintain original behavior
    // We're adapting the hook pattern from react-instantsearch to work with our input
    setShowResult(newQuery.length > 2);
    refine(newQuery);
  };

  const clearSearch = () => {
    setQuery('');
    setShowResult(false);

    if (inputRef.current) {
      inputRef.current.value = '';
      inputRef.current.focus();
    }
  };

  return (
    <div
      className={clsx(
        'tw-flex tw-h-12 tw-w-full tw-items-stretch tw-gap-2',
        searchContainerClassName
      )}
    >
      <div className="tw-relative tw-flex-grow">
        <SpiritoryInput
          ref={inputRef}
          value={query}
          onChange={onChange}
          onKeyDown={onKeyDown}
          searchIcon
          className={clsx(inputClassName)}
          placeholder={`${translationFallback(
            'search_something',
            t('search_something'),
            'Search something here'
          )}...`}
          rightIcon={
            query ? (
              <IoCloseOutline className="tw-cursor-pointer" onClick={clearSearch} />
            ) : undefined
          }
          onBlur={() => {
            event(
              'searchbar_filled',
              {
                event_category: 'interaction',
                device: 'Website',
              },
              { userId: userId, lang: router.locale }
            );
          }}
        />
      </div>
      {addButton && <button {...buttonProps} />}
    </div>
  );
}
